import styled from 'styled-components'
import { hideAtMobile, Media } from '@raysync/common/theme'
import { Column, Flex } from '@raysync/common/components'
export const CardContainer = styled.div`
  max-width: 900px;
  margin-left: -12px;
  margin-right: 52px;
  ${Media.phone`
    margin: 0;
  `}
`
export const DescColumn = styled(Column)`
  ${hideAtMobile}
`

export const PaginationWrapper = styled(Flex)`
  margin: 10px 0 60px 0;
  justify-content: flex-start;
`
export const SearchWrap = styled.div`
  display: flex;
  margin-bottom: 26px;
  input {
    width: 280px;
    height: 40px;
    border: 1px solid #dae0e5;
    outline: none;
  }
  button {
    width: 100px;
    height: 40px;
    border-radius: unset;
  }
`
export const BannerWrap = styled.div`
  margin: 40px 0 40px;
  .swiper-dot {
    position: relative;
    transform: translateY(-30px);
  }
`
